import { memo, useEffect } from 'react';
import { Typography, Form, Input, Button, Modal, App } from 'antd';
import { useTranslation } from 'translations';
import { useVisible, useRequest } from '@wappsto/blanket';
import ShowError from 'components/alerts/ShowError';

const ForgotPassword = memo(() => {
  const { tC } = useTranslation('features', 'requestPasswordRecovery');
  const [visible, show, hide] = useVisible();
  const { request, send } = useRequest();
  const loading = request?.status === 'pending';
  const { modal } = App.useApp();

  const handleSubmit = (values) => {
    try {
      if (!loading) {
        send({
          method: 'PATCH',
          url: '/register?request=recovery_password',
          body: {
            username: values.username,
          },
        });
      }
    } catch (e) {
      // form validation error
    }
  };

  useEffect(() => {
    if (request?.status === 'success') {
      modal.success({
        content: tC('emailSentInfo'),
        onOk: hide,
      });
    }
  }, [request, hide, tC, modal]);

  return (
    <>
      <Button type="link" onClick={show}>
        {tC('requestRecoveryButton')}
      </Button>
      <Modal
        title={tC('requestRecoveryTitle')}
        open={visible}
        onCancel={hide}
        footer={null}
        className="modal"
        destroyOnHidden>
        <Typography.Paragraph type="secondary">{tC('requestRecoveryInfo')}</Typography.Paragraph>
        <Form name="changePassword" onFinish={handleSubmit} layout="vertical">
          <Form.Item
            label={tC('username')}
            name="username"
            rules={[{ required: true, type: 'email' }]}>
            <Input />
          </Form.Item>
          <Form.Item>
            <ShowError request={request} />
            <Button type="primary" htmlType="submit" loading={loading}>
              {tC('sendButton')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
});

ForgotPassword.displayName = 'ForgotPassword';

export default ForgotPassword;
